module.exports = __webpack_public_path__ + "img/mobile_girl_one.faf90782.png";